/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Social_Sciences14Inputs */

const en_job_form_enum_social_sciences14 = /** @type {(inputs: Job_Form_Enum_Social_Sciences14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Sciences`)
};

const de_job_form_enum_social_sciences14 = /** @type {(inputs: Job_Form_Enum_Social_Sciences14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialwissenschaften`)
};

/**
* | output |
* | --- |
* | "Social Sciences" |
*
* @param {Job_Form_Enum_Social_Sciences14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_social_sciences14 = /** @type {((inputs?: Job_Form_Enum_Social_Sciences14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Social_Sciences14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_social_sciences14(inputs)
	return en_job_form_enum_social_sciences14(inputs)
});
export { job_form_enum_social_sciences14 as "job_form_enum_SOCIAL_SCIENCES" }